import React from "react";

const Cancel: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-latte">
    <h1 className="text-3xl font-bold text-espresso mb-4">Payment Canceled</h1>
    <p className="text-cocoa mb-8">Your upgrade was canceled. You can try again anytime.</p>
    <a
      href="/dashboard/home"
      className="px-6 py-3 rounded-full bg-caramel text-white font-semibold shadow hover:opacity-90"
    >
      Back to Dashboard
    </a>
  </div>
);

export default Cancel;